import { addDays, differenceInSeconds, startOfDay } from 'date-fns';

const getTimeUntilNextGame = () => (
  differenceInSeconds(startOfDay(addDays(Date.now(), 1)), Date.now())
);

export { getTimeUntilNextGame };
